/**
 * Secure the 'External JS Files' import (loading & init)
 *
 * @param {String} scriptURL : the name of the script to handle

 * @returns {Promise} : resolved when script is effectively (or already) loaded
 */

const POOL = {};

export default (scriptURL, reload = false) => {
  // Script not found in POOL : init it
  if (!POOL[scriptURL])
    POOL[scriptURL] = {
      loaded: false,
      loading: false,
    };
  if (POOL[scriptURL].loaded && !reload)
    // Script already loaded
    // -- resolve the promise directly
    return Promise.resolve();
  else if (POOL[scriptURL].loading)
    // Script is loading
    // -- wait for complete load, then resolve the promise
    return waitScriptLoading(scriptURL);
  // Script not loaded
  // -- trigger script load, then resolve the promise
  if (reload) removeScript(scriptURL);
  return initScriptLoading(scriptURL);
};

/**
 * Load and Init the Script loading
 * Flags are updated here
 *
 * @param {String} scriptURL
 */
const initScriptLoading = scriptURL =>
  new Promise((resolve, reject) => {
    // Append Script to page
    POOL[scriptURL].loading = true;
    const script = document.createElement('script');
    script.setAttribute('src', scriptURL);
    script.onload = () => {
      // Executed when script is loaded
      POOL[scriptURL].loading = false;
      POOL[scriptURL].loaded = true;
      // Resolve promise
      resolve();
    };
    script.onerror = () => {
      reject(new Error(`An error occured while loading the script ${scriptURL}`));
    };
    document.head.appendChild(script);
  });

/**
 * Script was inited somewhere else
 * Wait here (setInterval) until it's fully loaded
 * Then resolve the Promise once it's done
 *
 * @param {Script} scriptURL
 */
const waitScriptLoading = scriptURL =>
  new Promise(resolve => {
    // Script is already loading
    // Check every 200 ms
    const interval = setInterval(() => {
      if (POOL[scriptURL].loaded) {
        clearInterval(interval);
        resolve();
      }
    }, 200);
  });


const removeScript = scriptURL => {
  const existingScript = document.querySelector(`script[src="${scriptURL}"]`);
  if (existingScript) {
    existingScript.parentNode.removeChild(existingScript);
  }
};



// WEBPACK FOOTER //
// ./src/commons/utils/get-script.js